import {
  Divider, Grid, Container, Fade
} from '@material-ui/core';
import _ from 'lodash';
import React, {
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import * as moment from 'moment';
import configuration from '../../../../../configs/configuration';
import useResponsive from '../../../../../utils/responsive';
import {
  Button,
  CardItem,
  Map,
  Space,
  PlacesSearch,
} from '../../../../common';
import Display from '../../../../common/Display';
import Layout, { Main } from '../../Layout';
import { useLanguage } from '../../../../../context/language/language';
import useDeliveryControlFlow from '../../../../common/hook/useDeliveryControlFlow';
import useDeliveryData from '../../../../common/hook/useDeliveryData';
import useStoreLocation from '../../../../common/hook/useStoreLocation';
import { DELIVERY_SLOT, DELIVERY_TYPE_MENU } from '../../../../../constant/deliveryFlow';
import { useSite } from '../../../../../context/siteContext';
import { getIsPhoenix, getStoreOpenTime } from '../../../../../utils/utils';
import { StoreCloseWarning, StoreCloseWarningMobile } from '../../StoreCloseWarning';
import { defaultModalSize, mobileContentContainerHeight } from '../../modalSize';
import { getImageURL } from '../../../../../utils/getImageURL';
import { trackPageLoad } from '../../../../../utils/adobeAnalytics';
import { trackClickConfirmSelectDelivery } from '../../../../../utils/eventTracking';
import { is1HrStore, isPrive, isTDPK, isTalad } from '../../../../../utils/useSpecialStore';
import AlertToolTip from '../../../../AlertTooltip';

const isPhoenix = getIsPhoenix();

const CheckIcon = getImageURL('/icon/ic-checked-map.svg');
const iconSelected = getImageURL('/icon/ic-selected.svg');
const defaultImage = getImageURL('/images/store_default_thumbnail.svg');
const lotusGFImage = getImageURL('/images/lotus-go-fresh.svg');
const lotusHyperImage = getImageURL('/images/lotus-hyper.svg');
const lotusPriveImage = getImageURL('/images/lotus-prive.svg');
const lotusTaladImage = getImageURL('/images/lotus-talad.svg');
const lotusTDPKImage = getImageURL('/images/lotus-true-digital-park.svg');
const lotusGFMapImage = getImageURL('/images/lotus-go-fresh-map.svg');
const lotusHyperMapImage = getImageURL('/images/lotus-hyper-map.svg');
const lotusPriveMapImage = getImageURL('/images/lotus-prive-map.svg');
const lotusTaladMapImage = getImageURL('/images/lotus-talad-map.svg');
const lotusTDPKMapImage = getImageURL('/images/lotus-true-digital-park-map.svg');
const lotusGFMapSelectedImage = getImageURL('/images/lotus-go-fresh-map-selected.svg');
const lotusHyperMapSelectedImage = getImageURL('/images/lotus-hyper-map-selected.svg');
const lotusPriveMapSelectedImage = getImageURL('/images/lotus-prive-map-selected.svg');
const lotusTaladMapSelectedImage = getImageURL('/images/lotus-talad-map-selected.svg');
const lotusTDPKMapSelectedImage = getImageURL('/images/lotus-true-digital-park-map-selected.svg');
const FindStoreImg = getImageURL('/images/find_store.png');
const GofreshIcon = getImageURL('/icon/1h.svg');
const HyperIcon = getImageURL('/icon/3h.svg');
const closedIcon = getImageURL('/icon/closed_badge.svg');
const imgStoreNotFound = getImageURL('/icon/icon-store-not-found.svg');

const ImageView = styled('img')(({ theme }) => ({
  width: 140,
  height: 140,
  alignSelf: 'center',
}));

const BackgroundImage = styled.div(({ theme }) => ({
  ...theme.radius.xs,
  display: 'flex',
  width: theme.isMobile && 56,
  height: theme.isMobile && 56,
  marginRight: theme.isMobile ? 16 : 8,
  position: theme.isMobile ? 'relative' : 'static',
}));

const BtnChangeMethod = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  margin: 8,
  minWidth: 159,
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  height: 44,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

const BtnChangeAddress = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  margin: 8,
  color: theme.colors.grey700,
  backgroundColor: theme.colors.grey75,
  height: 44,
  minWidth: 159,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.grey25,
  },
}));

const Image = styled.img``;
const CustomImage = styled.img`
  position: ${(props) => (props.isOverlayed ? 'absolute' : 'relative')};
  left: ${(props) => (props.isOverlayed ? '25%' : '0%')};
  top: ${(props) => (props.isOverlayed ? 'calc(50% - 12px)' : '0%')};
  z-index: ${(props) => (props.isOverlayed ? 3 : 1)};
  width: ${(props) => (props.isOverlayed ? '24px' : '56px')};
  height: ${(props) => (props.isOverlayed ? '24px' : '56px')};
`;

const BackdropImage = styled.div`
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: #00000088;
  border-radius: 8px;
`;

const CollectionPointList = styled.div(({ theme }) => ({
  height: 'auto',

  ...theme.isDesktopOrLaptop && {
    height: 'initial',
  },
}));

const MapContainer = styled.div`
  margin-bottom: 0;
`;

const CustomSubheading = styled.div(({ theme, disabled }) => ({
  ...theme.fonts.textM,
  fontWeight: 700,
  color: theme.colors.grey700,
  wordWrap: 'break-word',
  opacity: disabled ? 0.5 : 1,
}));

const CustomParagraph = styled.div(({ theme, disabled }) => ([
  theme.isMobile
    ? {
      ...theme.fonts.textS,
      fontWeight: 400,
    } : {
      ...theme.fonts.textM,
      fontWeight: 500,
    }, {
    color: theme.colors.grey550,
    opacity: disabled ? 0.5 : 1,
    display: 'inline'
  }]));

const CustomCardItem = styled(CardItem)((props) =>
  ({
    height: 'auto',
    borderRadius: '15px',
    border: props.isSelected ? '2px solid #00bcb4' : 'none',
    padding: '8px 6px',
    margin: '0px 6px 8px 6px',
    backgroundColor: props.isSelected ? '#cef3f1' : '#ffffff',
  }));

const SelectedIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 5px;
`;

const StoreIcon = styled.img`
  height: 56px;
  width: 56px;
  position: sticky;
`;

const ClosedIcon = styled.img`
  width: 38px;
  height: 18px;
  top: 3px;
  position: relative;
`;

const checkLogo = (storeType = '', storeId = '') => {
  if (isTDPK(storeId)) return lotusTDPKImage;
  if (isPrive(storeId)) return lotusPriveImage;
  if (isTalad(storeId)) return lotusTaladImage;
  if (storeType === 'go_fresh') return lotusGFImage;
  if (storeType === 'hyper') return lotusHyperImage;
  return lotusHyperImage;
};

const checkMapLogo = (value = {}, currentStore = {}, ThSite = false) => {
  const { id: storeId, storeType } = value;
  const isSelected = ThSite && (storeId === currentStore?.id);
  if (isTDPK(storeId)) return isSelected ? lotusTDPKMapSelectedImage : lotusTDPKMapImage;
  if (isPrive(storeId)) return isSelected ? lotusPriveMapSelectedImage : lotusPriveMapImage;
  if (isTalad(storeId)) return isSelected ? lotusTaladMapSelectedImage : lotusTaladMapImage;
  if (storeType === 'go_fresh') return isSelected ? lotusGFMapSelectedImage : lotusGFMapImage;
  if (storeType === 'hyper') return isSelected ? lotusHyperMapSelectedImage : lotusHyperMapImage;
  return isSelected ? lotusHyperMapSelectedImage : lotusHyperMapImage;
};

export function Item({
  isSelected, data, onNext
}) {
  const { isMobile } = useResponsive();
  const word = useLanguage();
  const { ThSite } = useSite();
  const deliveryData = useDeliveryData();
  const storeOpeningTime = moment(data.storeOpeningTime).zone(ThSite ? '+07:00' : '+08:00').format('HH:mm');
  const storeClosingTime = moment(data.storeClosingTime).zone(ThSite ? '+07:00' : '+08:00').format('HH:mm');
  const timeText = word('Store.OpenHour').replace('%s', `${storeOpeningTime} - ${storeClosingTime}`);
  const storeId = isPhoenix ? data.code : data.id;

  if (isMobile) {
    if (deliveryData?.deliveryType === 'OD' && ThSite) {
      return (
        <>
          <CustomCardItem
            isSelected={isSelected}
            onClick={() => onNext(data)}
            disabled={data.isClosed}
            leftIcon={(
              <BackgroundImage isSelected={isSelected}>
                {isSelected && <BackdropImage />}
                {isSelected && <CustomImage src={CheckIcon} isOverlayed />}
                <CustomImage
                  src={checkLogo(data.storeType, storeId)}
                  isOverlayed={false}
                  isSelected={isSelected}
                />
              </BackgroundImage>
            )}
            content={(
              <>
                <CustomSubheading disabled={data.isClosed} isSelected={isSelected}>
                  {data.name}
                </CustomSubheading>
                {data.isClosed && <ClosedIcon src={closedIcon} />}
                <CustomParagraph disabled={data.isClosed}>
                  {!data.isClosed && `${data.proximityValue} ${data.proximityUnit} ·`}
                  {' '}
                  <AccessTimeIcon style={{
                    width: 11.67,
                    height: 11.67
                  }}
                  />
                  {' '}
                  {timeText}
                </CustomParagraph>
              </>
            )}
            storeIcon={data.storeType === 'hyper' && !is1HrStore(storeId) ? (
              <StoreIcon src={HyperIcon} />
            ) : (
              <StoreIcon src={GofreshIcon} />
            )}
          />
          <Divider />
        </>
      );
    }
    return (
      <>
        <CustomCardItem
          isSelected={isSelected}
          onClick={() => onNext(data)}
          leftIcon={(
            <BackgroundImage isSelected={isSelected}>
              {isSelected && <BackdropImage />}
              {isSelected && <CustomImage src={CheckIcon} isOverlayed />}
              <CustomImage
                src={checkLogo(data.storeType, storeId)}
                isOverlayed={false}
                isSelected={isSelected}
              />
            </BackgroundImage>
          )}
          content={(
            <>
              <CustomSubheading isSelected={isSelected}>
                {data.name}
              </CustomSubheading>
              <CustomParagraph>
                {
                  data.longAddress
                }
              </CustomParagraph>
            </>
          )}
        />
        <Divider />
      </>
    );
  }
  if (deliveryData.deliveryType === 'OD' && ThSite) {
    return (
      <div>
        <CardItem
          disabled={data.isClosed}
          leftIcon={(
            <BackgroundImage>
              <Image
                src={checkLogo(data.storeType, storeId)}
                onError={(e) => {
                  e.currentTarget.src = defaultImage;
                }}
              />
            </BackgroundImage>
          )}
          content={(
            <>
              <CustomSubheading disabled={data.isClosed}>{data.name}</CustomSubheading>
              {data.isClosed && <ClosedIcon src={closedIcon} />}
              <CustomParagraph disabled={data.isClosed}>
                {!data.isClosed && `${data.proximityValue} ${data.proximityUnit} ·`}
                {' '}
                <AccessTimeIcon style={{
                  width: 11.67,
                  height: 11.67,
                }}
                />
                {' '}
                {timeText}
              </CustomParagraph>
            </>
          )}
          storeIcon={data.storeType === 'hyper' && !is1HrStore(storeId) ? (
            <StoreIcon src={HyperIcon} />
          ) : (
            <StoreIcon src={GofreshIcon} />
          )}
          rightIcon={(
            <Button
              style={{
                height: 28,
                borderRadius: 8,
              }}
              id="branch-select-pre-order"
              data-cta-name-en="Select"
              data-cta-name-th="เลือก"
              data-cta-type="Button"
              onClick={() => onNext(data)}
            >
              {isSelected && <SelectedIcon src={iconSelected} />}
              {' '}
              <div style={{ color: 'white' }}>{word('General.Select')}</div>
            </Button>
          )}
        />
        <Divider />
      </div>
    );
  }
  return (
    <div>
      <CardItem
        leftIcon={(
          <BackgroundImage>
            <Image
              src={checkLogo(data.storeType, storeId)}
              onError={(e) => {
                e.currentTarget.src = defaultImage;
              }}
            />
          </BackgroundImage>
        )}
        content={(
          <>
            <CustomSubheading>{data.name}</CustomSubheading>
            <CustomParagraph>
              {data.proximityValue}
              {' '}
              {data.proximityUnit}
              {' ·'}
              {' '}
              {data.longAddress}
            </CustomParagraph>
          </>
        )}
        rightIcon={(
          <Button
            style={{
              height: 28,
              borderRadius: 8
            }}
            id="branch-select-pre-order"
            data-cta-name-en="Select"
            data-cta-name-th="เลือก"
            data-cta-type="Button"
            onClick={() => onNext(data)}
          >
            {isSelected && <SelectedIcon src={iconSelected} />}
            {' '}
            {word('General.Select')}
          </Button>
        )}
      />
      <Divider />
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  storeIcon: {
    width: 120,
    height: 'auto',
  },

  clickCollectNotfoundText: {
    ...theme.fonts.textM,
    color: '#6B6B6B',
    maxWidth: 311,
    height: 72,
    textAlign: 'center',
    wordWrap: 'break-word',
    textTransform: 'none'
  },

  notFoundText: {
    ...theme.fonts.textM,
    color: '#6B6B6B',
    minWidth: 170,
    textAlign: 'center',
    wordWrap: 'break-word',
    textTransform: 'none',
    whiteSpace: 'pre-line'
  },

  contentContainer: {
    padding: 0,
    minHeight: ({ contentMinHeight }) => contentMinHeight,

    [theme.breakpoints.up('lg')]: {
      padding: 0,
    },
  },
}));

export default function StoreLocation({
  onNext, onBack, onClose, modalRef,
}) {
  const classes = useStyle({ contentMinHeight: defaultModalSize.mobile.contentMinHeight });
  const { isMobile, isTablet } = useResponsive();
  const word = useLanguage();
  const { ThSite } = useSite();
  const deliveryControl = useDeliveryControlFlow();
  const deliveryData = useDeliveryData();
  const storeLocation = useStoreLocation();
  const timerRef = useRef();
  const contentContainerRef = useRef(null);
  const scrollContainer = useRef(null);
  const [hideSearch] = useState(deliveryData.deliveryMethod?.startsWith('H'));

  const isChangeMethod = deliveryData?.storeWithoutArea?.changeMethod;
  const activeAddress = deliveryData?.storeWithoutArea?.shippingAddress;
  const isStoreCloseAll = deliveryData?.storeWithoutArea?.storeCloseAll;
  const latitude = isChangeMethod ? activeAddress?.latitude : deliveryData?.shippingAddress?.latitude;
  const longitude = isChangeMethod ? activeAddress?.longitude : deliveryData?.shippingAddress?.longitude;
  const [latLng, setLatLng] = useState({
    lat: latitude || '',
    lng: longitude || '',
  });
  const [address, setAddress] = useState('');
  const [disableScrollY, setDisableScrollY] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [isPlaceSearch, setIsPlaceSearch] = useState(false);
  const lotusRama1 = { lat: 13.748013948421677, lng: 100.52443341259537 };
  const myDefault = { lat: 3.1386299225989105, lng: 101.68574698006697 };
  const collectionPointList = storeLocation.storeData;
  const storeType = deliveryData.formData.filter?.storeType;
  const currentStore = deliveryData?.currentStore;
  const [enableGeo, setEnableGeo] = useState(null);
  const [isHDND, setIsHDND] = useState();
  const [disableBtn, setDisableBtn] = useState(false);
  const isMY = configuration?.siteCode === 'MY';
  const [currentAddress, setCurrentAddress] = useState({});
  const [emptyStore, setEmptyStore] = useState(false);

  const [deliveryType, setDeliveryType] = useState(undefined);
  const [deliveryMethod, setDeliveryMethod] = useState(undefined);
  const [openTooltip, setOpenTooltip] = useState(true);

  const onScroll = (event) => {
    if (event.target?.scrollTop >= 50) {
      setOpenTooltip(false);
    } else {
      setOpenTooltip(true);
    }
  };

  useEffect(() => {
    scrollContainer?.current?.addEventListener('scroll', onScroll);
    return () => {
      scrollContainer?.current?.removeEventListener('scroll', onScroll);
    };
  }, []);

  useEffect(() => {
    const onChangePermission = (result) => {
      if (
        result.state === 'denied'
        && (latLng.lat === undefined || latLng.lat === '')
      ) {
        if (configuration.siteCode === 'MY') {
          setLatLng(myDefault);
        } else {
          setLatLng(lotusRama1);
        }
      }
      // else if (result.state === 'granted') {
      //   setIsSetDefaultLocation(true);
      // }
    };

    if (navigator.geolocation && navigator.permissions) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((result) => {
          onChangePermission(result);
          result.onchange = () => {
            onChangePermission(result);
          };
          if (result.state === 'denied') {
            setEnableGeo(false);
          } else if (result.state === 'granted') {
            setEnableGeo(true);
          }
        });
    }
  }, []);

  useEffect(() => {
    if ((collectionPointList !== null && collectionPointList !== undefined) && !storeLocation.storeLoading) {
      let storeList;
      // check store close all when delivery is empty (widget, header select store (1hr))
      if (isStoreCloseAll) {
        storeList = collectionPointList?.stores?.filter((store) => !store.isClosed) || [];
      } else {
        storeList = [...(collectionPointList?.stores || [])];
      }
      // eslint-disable-next-line no-use-before-define
      const isEmpty = filterStoreType(storeList)?.length === 0;
      setEmptyStore(isEmpty);
    }
  }, [collectionPointList, storeLocation.storeLoading]);

  useEffect(() => {
    if (isHDND === undefined) {
      if (isMY) {
        setIsHDND(deliveryData?.deliveryMethod === 'HD' && deliveryData?.deliveryType === 'SFL');
      } else {
        setIsHDND(deliveryData?.deliveryMethod === 'HDND');
      }
      const deliType = _.get(deliveryData, 'storeWithoutArea.activeDelivery.deliveryType', deliveryData?.deliveryType);
      const deliMethod = _.get(deliveryData, 'storeWithoutArea.activeDelivery.deliveryMethod', deliveryData?.deliveryMethod);
      setDeliveryType(deliType);
      setDeliveryMethod(deliMethod);
    }
  }, [deliveryData?.deliveryMethod]);

  useMemo(() => {
      const changeMethod = _.get(deliveryData, 'storeWithoutArea.changeMethod', false);
      setDisableBtn(changeMethod);
  }, []);

  useEffect(() => {
    storeLocation.clearData();
    trackPageLoad(deliveryData.deliveryMethod?.startsWith('CC') ? 'Collect Store Search' : 'Search Store List');
    const { latitude, longitude, postcode } = deliveryData.shippingAddress;
    timerRef.current = setTimeout(() => {
      if (!latLng.lat) {
        if (ThSite) {
          setLatLng(lotusRama1);
        } else {
          setLatLng(myDefault);
        }
      }
    }, 5000);
    if (!latitude && !longitude && !postcode) return;

    return () => {
      storeLocation.clearData();
    };
  }, []);

  const locations = useMemo(() => (collectionPointList?.stores || []).map((value) => ({
    name: value.name,
    icon: checkMapLogo(value, currentStore, ThSite),
    location: {
      lat: value.latitude,
      lng: value.longitude,
    },
    isSelected: ThSite && (value?.id === currentStore?.id),
    isClosed: value.isClosed,
  })), [collectionPointList]);

  const isOnDemand = deliveryData.deliveryType === 'OD';
  const warningStoreOpenTime = getStoreOpenTime();
  const storeCloseWarningDesktop = isOnDemand && warningStoreOpenTime.isClose && <StoreCloseWarning time={warningStoreOpenTime.time} />;
  const storeCloseWarningMobile = isOnDemand && warningStoreOpenTime.isClose && <StoreCloseWarningMobile time={warningStoreOpenTime.time} />;

  useEffect(() => {
    mobileContentContainerHeight(contentContainerRef, isMobile, modalRef);
  }, [contentContainerRef]);

  useEffect(() => {
    if (emptyStore && isMobile) {
      contentContainerRef.current.style.height = 'auto';
    }
  }, [emptyStore]);

  const handleChange = (address) => {
    setAddress(address);
    setIsSearch(Boolean(address));
  };

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then((results) => {
        const data = getLatLng(results[0]);
        setAddress(address);
        return data;
      })
      .then((latLng) => {
        setLatLng(latLng);
        setIsSearch(false);
        return latLng;
      });
  };

  const handleClick = () => {
    setIsPlaceSearch(true);
    localStorage.setItem('isDisableTooltipInPopup', true);
  };

  const handlerSearchError = (status) => {
    setDisableScrollY(Boolean(status));
  };

  const filterStoreType = (stores) => (
    (storeType && stores && ThSite)
      ? stores.filter((store) => {
        const storeId = isPhoenix ? store?.code : store?.id;
        if (is1HrStore(storeId)) {
          return storeType === 'go_fresh';
        }
        return store.storeType === storeType;
      })
      : stores
  );

  const setHeaderSpace = () => {
    if (isTablet) {
      return 2;
    }
    if (isMobile) {
      return 0.1;
    }
    return 3;
  };

  const deliveryChangeMethod = () => {
    const filterStoreType = _.get(deliveryData, 'formData.filter.storeType', '');
    const storeType = _.get(deliveryData, 'activeStore.storeType', '');
    if (isHDND) {
      // next days change method to same days
      const activeDelivery = { deliveryType, deliveryMethod };
      deliveryControl.setStoreWithoutAreaMethodChange(true, currentAddress, activeDelivery);
      deliveryControl.startOnDemand({ activeData: { shippingAddress: currentAddress } });
      deliveryControl.setFromWidget(false);
    } else if (storeType === 'go_fresh' && isMobile) {
      // same day change method to etc.
      if (filterStoreType === 'go_fresh') {
        deliveryControl.setDisableGoFresh(true);
      } else {
        deliveryControl.setDisableHyper(true);
      }
      const activeDelivery = { deliveryType, deliveryMethod };
      deliveryControl.setStoreWithoutAreaMethodChange(true, currentAddress, activeDelivery);
      deliveryControl.openDeliveryDialog(DELIVERY_TYPE_MENU);
    } else if (storeType === 'hyper' && isMobile) {
      deliveryControl.setDisableHyper(true);
      if (filterStoreType === 'hyper') {
        deliveryControl.setDisableHyper(true);
      } else {
        deliveryControl.setDisableGoFresh(true);
      }
      const activeDelivery = { deliveryType, deliveryMethod };
      deliveryControl.setStoreWithoutAreaMethodChange(true, currentAddress, activeDelivery);
      deliveryControl.openDeliveryDialog(DELIVERY_TYPE_MENU);
    } else {
      const activeDelivery = { deliveryType, deliveryMethod };
      deliveryControl.setStoreWithoutAreaMethodChange(true, currentAddress, activeDelivery);

      deliveryControl.setHideOnDemand(true);
      deliveryControl.setFromWidget(true);
      deliveryControl.openDeliveryDialog(DELIVERY_TYPE_MENU);
    }
  };

  const renderStoreError = () => {
    let message = word('Store.Error.Notfound').replace(/\\n/g, '\n');
    let btnNotfoundMessage = word('Store.Error.NextDay.Notfound.Button');
    let disableSFL = false;
    if (deliveryData?.deliveryMethod === 'B2B') {
      message = word('Slot.Error.Notfound.B2B').replace(/\\n/g, '\n');
      disableSFL = true;
    } else if (deliveryData?.deliveryType === 'SFL' && deliveryData?.deliveryMethod.startsWith('CC')) {
      message = word('Store.Error.ClickCollect.Notfound');
      btnNotfoundMessage = word('Store.Error.OutOfServiceArea.ChangeMethod.Button');
      disableSFL = true;
    } else if (deliveryType === 'OD') {
      const text = isStoreCloseAll ? 'Store.Error.OnDemand.Closed' : 'Store.Error.OnDemand.Notfound';
      message = word(text).replace(/\\n/g, '\n');
      btnNotfoundMessage = word('Store.Error.OnDemand.Notfound.Button');
    }
    return (
      <>
        <Grid item>
          <Typography variant="h4" className={classes.notFoundText}>
            {message}
          </Typography>
        </Grid>
        {
          (!disableBtn && !disableSFL) && (
            <Grid
              item
              style={isMobile ? { borderTop: 'solid 1px #E0E0E0', paddingTop: 12, marginTop: 25 } : { paddingTop: 12 }}
            >
              <BtnChangeAddress
                id="btn-change-address"
                data-cta-name-en="change-address"
                data-cta-name-th="เปลี่ยนที่อยู่"
                data-cta-type="Button"
                onClick={() => {
                  deliveryControl.setStoreWithoutAreaMethodChange(true);
                  deliveryControl.startDeliveryAddress();
                }}
              >
                {word('Store.Error.OutOfServiceArea.Button')}
              </BtnChangeAddress>
              {
                !isMY && (
                  <BtnChangeMethod
                    id="btn-delivery-change-method"
                    data-cta-name-en="btn-delivery-change-method"
                    data-cta-name-th="เปลี่ยนการจัดส่ง"
                    data-cta-type="Button"
                    onClick={deliveryChangeMethod}
                  >
                    {btnNotfoundMessage}
                  </BtnChangeMethod>
                )
              }
            </Grid>
          )
        }
      </>
    );
  };

  return (
    <Layout
      containerRef={scrollContainer}
      title={word('StoreSelection.Title')}
      onBack={onBack}
      onClose={() => {
        deliveryControl.closeModal(true);
        onClose();
      }}
      backButtonShown={deliveryControl.stackSize > 1}
      headerSpace={setHeaderSpace()}
      storeCloseWarningDesktop={storeCloseWarningDesktop}
      storeCloseWarningMobile={storeCloseWarningMobile}
      width={isTablet ? defaultModalSize.tablet.width : defaultModalSize.desktop.width}
      height={isTablet ? defaultModalSize.tablet.height : defaultModalSize.desktop.height}
      scrollY={!disableScrollY}
    >
      <Container className={classes.contentContainer} ref={contentContainerRef}>
        <Main noPaddingX>
          {deliveryData.deliveryMethod?.startsWith('CC')
            && (
              <>
                <AlertToolTip
                  tooltipText={word('Tooltips.ClickCollect')}
                  localStorageName="isDisableTooltipInPopup"
                  openTooltip={!enableGeo && !isPlaceSearch && openTooltip}
                >
                  <div style={{ width: '100%' }}>
                    <PlacesSearch
                      value={address}
                      onSearch={handleChange}
                      onSelect={handleSelect}
                      onError={handlerSearchError}
                      floating
                      notShowTooltip
                      onClick={handleClick}
                    />
                  </div>
                </AlertToolTip>
                <div style={{ marginBottom: 25 }} />
              </>
            )}
          <Fade in={!isSearch}>
            <div>
              <MapContainer>
                <Map
                  locations={isStoreCloseAll ? [] : locations}
                  latLng={latLng}
                  onLocationChange={async (position, address) => {
                    storeLocation.getStoreLocation(address);
                    setLatLng(position);
                    setCurrentAddress(address);
                    clearTimeout(timerRef.current);
                  }}
                  hideCurrent={hideSearch}
                  draggable={!disableBtn}
                />
              </MapContainer>
              <Display show={!storeLocation.storeLoading && filterStoreType([...(collectionPointList?.stores || [])])?.length > 0}>
                <Space line={1.5} />
              </Display>
              <CollectionPointList
                isSelected={
                  collectionPointList
                  && collectionPointList.stores
                  && collectionPointList?.stores.find((store) => store.id === deliveryData.currentStore.storeId)
                }
              >
                <Display show={!isStoreCloseAll}>
                  {
                    !_.isNil(collectionPointList?.stores)
                      && !_.isEmpty(collectionPointList?.stores)
                      && filterStoreType([...collectionPointList?.stores]).sort((a, b) => a.proximityValue - b.proximityValue)
                        .map((loc, k) => (
                          <Item
                            isSelected={deliveryData.currentStore.storeId === loc.id}
                            data={loc}
                            key={`storeId-${loc.id}`}
                            onNext={(data) => {
                              localStorage.removeItem('storeData');
                              localStorage.setItem('storeData', JSON.stringify(data));
                              onNext(data, DELIVERY_SLOT);
                              if (isOnDemand) {
                                trackClickConfirmSelectDelivery({
                                  selected_delivery_type: deliveryData.activeDeliveryType,
                                  selected_delivery_method: deliveryData.activeDeliveryMethod,
                                  selected_store_id: isPhoenix ? data.code : data.id,
                                  selected_store_name: data.name,
                                  selected_store_type: data.storeType === 'hyper' ? 'HY' : 'GF',
                                  selected_time: '',
                                });
                              }
                            }}
                          />
                        ))
                  }  
                </Display>
                <Display show={!storeLocation.storeLoading && emptyStore}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    style={{ height: '100%' }}
                  >
                    <Grid item>
                      <ImageView src={imgStoreNotFound} alt="no store available" />
                    </Grid>
                    {
                      renderStoreError()
                    }
                  </Grid>
                </Display>
              </CollectionPointList>
            </div>
          </Fade>
        </Main>
      </Container>
    </Layout>
  );
}
